import { isEmpty, translationUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { JsTreeView, Td } from '@festina-life/ui/listsAndTables'
import type { JSX } from 'react'

type Props<T> = {
  value: T
}

export const DiffObjectCell = <T,>({ value }: Props<T>): JSX.Element => {
  const translate = useTranslate()

  if (isEmpty(value)) {
    return <Td />
  }

  if (typeof value === 'boolean') {
    return <Td>{translationUtils.translateBoolean(value, translate)}</Td>
  }

  if (typeof value === 'object') {
    return (
      <Td>
        <JsTreeView data={value} />
      </Td>
    )
  }

  return <Td>{`${value}`}</Td>
}
